import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export default api;

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function imgSrc(u) {
  if (!u) return u;
  return u.startsWith("http") ? u : `${BACKEND}${u}`;
}

const trim = (n) => (Number.isInteger(n) ? n.toString() : n.toFixed(2).replace(/\.?0+$/, ""));

export function formatINR(value, unit = "total") {
  const v = Number(value) || 0;
  let out;
  if (v >= 1e7) out = `₹${trim(v / 1e7)} Cr`;
  else if (v >= 1e5) out = `₹${trim(v / 1e5)} L`;
  else out = `₹${v.toLocaleString("en-IN")}`;
  return unit === "monthly" ? `${out}/mo` : out;
}

export function fmtErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
}

export const LEAD_STATUSES = ["new", "assigned", "contacted", "site_visit", "negotiation", "won", "lost"];

export const LEAD_STATUS_LABELS = {
  new: "New",
  assigned: "Assigned",
  contacted: "Contacted",
  site_visit: "Site Visit",
  negotiation: "Negotiation",
  won: "Won",
  lost: "Lost",
};

export const LEAD_STATUS_COLORS = {
  new: "bg-sky-100 text-sky-900",
  assigned: "bg-violet-100 text-violet-900",
  contacted: "bg-amber-100 text-amber-900",
  site_visit: "bg-cyan-100 text-cyan-900",
  negotiation: "bg-orange-100 text-orange-900",
  won: "bg-emerald-100 text-emerald-900",
  lost: "bg-neutral-200 text-neutral-600",
};

export const LISTING_STATUS_COLORS = {
  draft: "bg-neutral-200 text-neutral-600",
  pending_review: "bg-amber-100 text-amber-900",
  published: "bg-emerald-100 text-emerald-900",
  rejected: "bg-red-100 text-red-900",
};

export const ROLE_LABELS = {
  super_admin: "Admin",
  builder: "Builder",
  agent: "Agent",
  buyer: "Buyer",
  internal_sales: "Internal Sales",
};
